export default __webpack_public_path__ + "static/media/contacted_matches.c3094662.svg";